// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Loader = require("../common/Components/Loader.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let ReadMoreButton = require("../../components/buttons/ReadMoreButton.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MyBroadcastMessagesWidgetListItem = require("./MyBroadcastMessagesWidgetListItem.bs.js");
let MyBroadcastMessagesWidgetList_query_graphql = require("../../__generated__/MyBroadcastMessagesWidgetList_query_graphql.bs.js");
let MyBroadcastMessagesWidgetListPaginationQuery_graphql = require("../../__generated__/MyBroadcastMessagesWidgetListPaginationQuery_graphql.bs.js");

let getConnectionNodes = MyBroadcastMessagesWidgetList_query_graphql.Utils.getConnectionNodes;

let convertFragment = MyBroadcastMessagesWidgetList_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyBroadcastMessagesWidgetList_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyBroadcastMessagesWidgetList_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MyBroadcastMessagesWidgetList_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyBroadcastMessagesWidgetList_query_graphql.node, convertFragment, fRef);
}

let makeRefetchVariables = MyBroadcastMessagesWidgetListPaginationQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables = MyBroadcastMessagesWidgetListPaginationQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(MyBroadcastMessagesWidgetList_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

function usePagination(fRef) {
  return RescriptRelay_Fragment.usePaginationFragment(MyBroadcastMessagesWidgetList_query_graphql.node, fRef, convertFragment, convertRefetchVariables);
}

let QueryFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable,
  usePagination: usePagination
};

function MyBroadcastMessagesWidgetList$MyBroadcastMessagesEmpty(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      "You have not broadcast any messages.",
      JsxRuntime.jsx("br", {}),
      JsxRuntime.jsx("br", {}),
      "Want to connect with other agents on rentals, industry discussion and other topics? ",
      JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: "/messages/new",
        className: "hover:underline",
        children: "Broadcast a message now"
      })
    ]
  });
}

let MyBroadcastMessagesEmpty = {
  make: MyBroadcastMessagesWidgetList$MyBroadcastMessagesEmpty
};

function MyBroadcastMessagesWidgetList(props) {
  let match = usePagination(props.query);
  let isLoadingNext = match.isLoadingNext;
  let hasNext = match.hasNext;
  let loadNext = match.loadNext;
  let data = match.data;
  let items = getConnectionNodes(data.messageBroadcastsForCurrentUser);
  let tmp;
  tmp = props.viewMoreMode === "ShowAllButton" ? (
      hasNext ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ReadMoreButton.make, {
            href: "/my_broadcast_messages",
            children: "View All"
          }),
          className: "mt-4"
        }) : null
    ) : (
      hasNext ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            onClick: param => {
              loadNext(30, undefined);
            },
            disabled: isLoadingNext,
            className: "w-full",
            children: "See More Messages"
          }),
          className: "mt-4"
        }) : null
    );
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      items.length !== 0 ? JsxRuntime.jsx("div", {
          children: items.map(item => {
            let match = data.messageBroadcastsForCurrentUser;
            return JsxRuntime.jsx(MyBroadcastMessagesWidgetListItem.make, {
              message: item.fragmentRefs,
              listConnectionId: match !== undefined ? Primitive_option.some(match.__id) : undefined
            }, item.nodeId);
          }),
          className: "flex flex-col border-b mb-6"
        }) : JsxRuntime.jsx(MyBroadcastMessagesWidgetList$MyBroadcastMessagesEmpty, {}),
      tmp,
      isLoadingNext ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loader.make, {
            loadingText: "Loading more messages..."
          }),
          className: "mt-4"
        }) : null
    ]
  });
}

let make = MyBroadcastMessagesWidgetList;

exports.QueryFragment = QueryFragment;
exports.MyBroadcastMessagesEmpty = MyBroadcastMessagesEmpty;
exports.make = make;
/* Loader Not a pure module */
